export const openFullModal = (settings) => {
    console.log('modal opened')

    let options = jQuery.extend({
        modalTitle: "La Parfumerie",
        showProgressBar: true,
        modalBodyContent: false
    }, settings);

    let modal = $('.alis-full-modal:not(.copied)').clone();

    // extend width opened modals
    let openedModals = $('.alis-full-modal.copied');
    $(openedModals).addClass('--full-width');

    // mark as copied modal
    modal.addClass('copied')

    // set props
    modal.find('.modal-title').text(options.modalTitle);
    if (options.showProgressBar) {
        modal.addClass('--show-progress-bar');
    }
    if (options.modalBodyContent) {
        let modalBodyContent = $(options.modalBodyContent);

        if ($(modalBodyContent).length !== 0) {
            console.log(modalBodyContent)
            modal.find('.modal-body').html(modalBodyContent.html())
        }
    }

    // append modal to body and show
    modal.appendTo('body')
    modal.modal('show')

    // set event listener
    modal.on('hide.bs.modal', function () {
        // remove extend class previous modal
        $('.alis-full-modal.--full-width').last().removeClass('--full-width');
    });

    modal.on('hidden.bs.modal', function () {
        // remove from dom
        $(this).remove();
    });

    return modal;
}